var render, staticRenderFns
import script from "./PieChart.vue?vue&type=script&lang=js"
export * from "./PieChart.vue?vue&type=script&lang=js"
import style0 from "./PieChart.vue?vue&type=style&index=0&id=b11cace0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11cace0",
  null
  
)

/* custom blocks */
import block0 from "./PieChart.vue?vue&type=custom&index=0&blockType=canvas&ref=pieChart"
if (typeof block0 === 'function') block0(component)

export default component.exports